import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import cn from 'classnames';
import { Box } from '../Layout/Box';
import s from './FileDropzone.module.scss';
export const FileDropzone = (param)=>{
    let { accept, disabled, testId, inputTestId, onFileSelected, renderContent, className } = param;
    const fileInputRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const actualInputTestId = inputTestId !== null && inputTestId !== void 0 ? inputTestId : testId ? "".concat(testId, "-input") : undefined;
    const handleClick = ()=>{
        if (!disabled) {
            var _fileInputRef_current;
            (_fileInputRef_current = fileInputRef.current) === null || _fileInputRef_current === void 0 ? void 0 : _fileInputRef_current.click();
        }
    };
    const handleFileChange = (e)=>{
        var _e_target_files;
        const file = (_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0];
        if (file) {
            onFileSelected(file);
        }
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    const handleDrop = (e)=>{
        var _e_dataTransfer_files;
        e.preventDefault();
        setIsDragging(false);
        const file = (_e_dataTransfer_files = e.dataTransfer.files) === null || _e_dataTransfer_files === void 0 ? void 0 : _e_dataTransfer_files[0];
        if (file) {
            onFileSelected(file);
        }
    };
    const handleDragOver = (e)=>{
        e.preventDefault();
        setIsDragging(true);
    };
    const handleDragLeave = ()=>{
        setIsDragging(false);
    };
    return /*#__PURE__*/ _jsxs(Box, {
        testId: testId,
        className: cn(s.dropzone, className, {
            [s.disabled]: disabled,
            [s.dragging]: isDragging
        }),
        onClick: handleClick,
        onDrop: handleDrop,
        onDragOver: handleDragOver,
        onDragLeave: handleDragLeave,
        children: [
            /*#__PURE__*/ _jsx("input", {
                ref: fileInputRef,
                type: "file",
                accept: accept,
                className: s.hiddenInput,
                onChange: handleFileChange,
                "data-testid": actualInputTestId
            }),
            renderContent({
                isDragging
            })
        ]
    });
};
